import { defineComponent as a, createBlock as n, openBlock as l, unref as r, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconThumbsUpFilled",
  __name: "IconThumbsUpFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (l(), n(r(m), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M19.73 11.934a2.067 2.067 0 0 0 .533-.36 1.924 1.924 0 0 0 0-2.814c-.41-.384-.977-.593-1.638-.593H12.54l.476-2.383a3.046 3.046 0 0 0-1.624-3.323 1.21 1.21 0 0 0-1.648.594l-3.172 7.191a5.25 5.25 0 0 0-.165.42H4.375a1.25 1.25 0 0 0-1.25 1.25v6a1.25 1.25 0 0 0 1.25 1.25h2.5a.736.736 0 0 0 .08-.004 2.241 2.241 0 0 0 1.42.505h7.75c.66 0 1.229-.21 1.638-.594a1.924 1.924 0 0 0 .464-2.146c.706-.343 1.124-1.013 1.13-1.754a1.92 1.92 0 0 0-.25-.968 1.924 1.924 0 0 0 .623-2.271M6.139 17.667a2.275 2.275 0 0 1-.014-.25v-5.052a5.254 5.254 0 0 1 .004-.199H4.625v5.5h1.514",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
